module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "ini-bot light-black hvr-grow-rotate",
    attrs: {
      "aria-label": _vm.aria
    }
  }, [_vm._v("\n  Haga"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "part-1 font-red"
  }, [_vm._v("CLIC")]), _c('br'), _vm._v("-para-"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "part-2 font-red davi-curs"
  }, [_vm._v("continuar")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e3a56662","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Buttoncirclesecondary.vue
// module id = 1052
// module chunks = 1